import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Paragraph } from '@fs/zion-ui'
import { Link } from '@fs/zion-router'
import { getNameRelatedData } from '@fs/zion-person-service'
import { i18n } from '@fs/zion-locale'

export default function MemoryCallToAction({ person, loggedIn = false, baseUrl }) {
  const [t] = useTranslation()
  const { shortName } = getNameRelatedData(person)
  const pid = person.id
  /* In CJK languages, we want to avoid bold text. */
  const langCJK = ['zh', 'ja', 'ko'].includes(i18n.language)
  const BoldOrNoBold = langCJK ? 'span' : 'b'

  let linkUrl = baseUrl
  if (!baseUrl) {
    linkUrl = ''
  }

  return (
    <Paragraph centered size="sm">
      <BoldOrNoBold>
        {t(
          shortName
            ? 'info-cards.no-memories.do-you-know.subheader'
            : 'info-cards.no-memories.do-you-know.subheader-this-person.subheader',

          {
            shortName,
          }
        )}
      </BoldOrNoBold>{' '}
      {t('info-cards.no-memories.do-you-have-a-story', { gender: person?.gender?.toLowerCase() })}{' '}
      {!loggedIn && (
        <Link
          to={`${linkUrl}/tree/person/memories/${pid}`}
          linkName="Memories: Sign In"
          data-testid="sign-in-link-action"
          external
        >
          {t('common-ui:sign-in.action')}
        </Link>
      )}{' '}
      {!loggedIn && t('info-cards.no-memories.or.text')}{' '}
      {!loggedIn && (
        <Link
          to={`${linkUrl}/identity/signup/`}
          linkName="Memories: Create a FREE Account"
          data-testid="sign-in-link-action"
          external
        >
          {t('info-cards.create-free-account.action')}
        </Link>
      )}
      {loggedIn && (
        <Link
          to={`${linkUrl}/memories/gallery?openStoryUploader=true`}
          linkName="Memories: Write a Story"
          data-testid="sign-in-link-action"
          external
        >
          {t('info-cards.write-a-story.action')}
        </Link>
      )}
    </Paragraph>
  )
}

// Stryker disable all
MemoryCallToAction.propTypes = {
  /** Person object for the person who's memories are being displayed. */
  person: PropTypes.shape({}),
  /** Whether or not to make the call to action look raised with a box shadow */
  raised: PropTypes.bool,
}
